import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const dtEntityRequest = createAction(types.DT_ENTITIES_REQUEST);
export const dtEntitySuccess = createAction(types.DT_ENTITIES_SUCCESS);
export const dtEntityFailure = createAction(types.DT_ENTITIES_FAILURE);

export default {
  dtEntityRequest,
  dtEntitySuccess,
  dtEntityFailure,
};
